import React, { useState, useEffect } from "react";
import "./index.css";
import Home from "./routes/home";
import Contact from "./routes/contact";
import Projects from "./routes/projects";
import About from "./routes/about";
import Loader from "./components/Loader";
import { Route, Routes, useNavigate } from "react-router-dom";

function App() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time, replace this with your actual data loading logic
    setTimeout(() => {
      setLoading(false);
    }, 5000); // 5 seconds
  }, []);

  return (
    <div className="App">
      {loading ? (
        <div className="loader-page">
          <div className="loader"></div>
        </div>
      ) : (
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
        </Routes>
      )}
    </div>
  );
}

export default App;
